module.exports = __webpack_public_path__ + "img/TCabTech.371f0cae.jpg";